// removed by extract-text-webpack-plugin
module.exports = {"container":"_22mblggUULzn4vfMsYgzC-","IconTrailing":"xXGTnxcFA07QfIcj4lZYu","Icon":"_3Er5xKZp6d3kSqM0dDU4CQ","Name":"K9WsFwJ4n4w9rdVVOrmWK","Button":"KDsTxceh7O3iADAnuHFbc","Email":"_1nHaXn9d0K907MHbqg8HXh","verify":"_1KA-lK33oXt3vv_U7RSYpB","Signer":"_1pavuLr4FD4TdhQJ2IFjWb"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/PubDocumentVerify/DocVerifier/Verify/styles.css
// module id = 3015
// module chunks = 0